import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function DoctorProfile() {
  const { user } = useAuth();
  const [doctor, setDoctor] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user?.doctor_id) return;
    api.get(`/doctors/${user.doctor_id}`).then((r) => setDoctor(r.data));
  }, [user]);

  const set = (k) => (e) => setDoctor({ ...doctor, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { name, specialty, qualifications, experience_years, clinic, location, about, fee } = doctor;
      await api.patch(`/doctors/${doctor.id}`, {
        name, specialty, qualifications, experience_years: Number(experience_years), clinic, location, about, fee: Number(fee),
      });
      toast.success("Profile updated");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  if (!doctor) return <div className="py-20 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;

  return (
    <div className="max-w-3xl space-y-6">
      <h1 className="text-3xl font-bold text-slate-900">Doctor profile</h1>
      <form onSubmit={save} className="doccare-card p-6 space-y-4">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>Name</Label><Input value={doctor.name || ""} onChange={set("name")} className="mt-1.5 rounded-xl h-11" /></div>
          <div><Label>Specialty</Label><Input value={doctor.specialty || ""} onChange={set("specialty")} className="mt-1.5 rounded-xl h-11" /></div>
          <div><Label>Qualifications</Label><Input value={doctor.qualifications || ""} onChange={set("qualifications")} className="mt-1.5 rounded-xl h-11" /></div>
          <div><Label>Experience (years)</Label><Input type="number" value={doctor.experience_years || 0} onChange={set("experience_years")} className="mt-1.5 rounded-xl h-11" /></div>
          <div><Label>Clinic</Label><Input value={doctor.clinic || ""} onChange={set("clinic")} className="mt-1.5 rounded-xl h-11" /></div>
          <div><Label>Location</Label><Input value={doctor.location || ""} onChange={set("location")} className="mt-1.5 rounded-xl h-11" /></div>
          <div><Label>Fee ($)</Label><Input type="number" value={doctor.fee || 0} onChange={set("fee")} className="mt-1.5 rounded-xl h-11" /></div>
        </div>
        <div><Label>About</Label><Textarea value={doctor.about || ""} onChange={set("about")} className="mt-1.5 rounded-xl min-h-24" /></div>
        <Button type="submit" disabled={saving} className="rounded-xl">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save"}
        </Button>
      </form>
    </div>
  );
}
